import { render, staticRenderFns } from "./createVoice.vue?vue&type=template&id=c296ca0c&scoped=true"
import script from "./createVoice.vue?vue&type=script&lang=js"
export * from "./createVoice.vue?vue&type=script&lang=js"
import style0 from "./createVoice.vue?vue&type=style&index=0&id=c296ca0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c296ca0c",
  null
  
)

export default component.exports